import { RoutalPalette } from '@nx-smartmonkey/ui';

import { PropsWithChildren } from 'react';
import { AddressItem, AddressRow } from '../../../../../components/data-importer/ReviewAddressesStyles';
import { StopDTO } from '../../../../../domain/stop/StopDTO';
import InputLocation from '../../../../../react-components/InputLocation';
import Text from '../../../../../react-components/Text';
import { CreateClientsList } from '../fields/CreateClientsList';

const TextWithLineClamp = ({ children }: PropsWithChildren<{}>) => {
  return (
    <Text
      style={{
        display: `-webkit-box`,
        WebkitBoxOrient: `vertical`,
        WebkitLineClamp: 3,
        overflow: `hidden`,
        textOverflow: `ellipsis`,
      }}
    >
      {children}
    </Text>
  );
};

interface ReviewAddressesDataRowProps {
  index: number;
  style: any;
  data: {
    showErrors: boolean;
    showWarnings: boolean;
    createStopsList: CreateClientsList;
    setCreateClientsList: (createClientsList: CreateClientsList) => void;
  };
}

export const ReviewAddressesDataRow = ({ index, style, data }: ReviewAddressesDataRowProps) => {
  const { showErrors, showWarnings, createStopsList, setCreateClientsList } = data;

  // DES D'AQUÍ EL FILTER
  const stopsData = createStopsList.getClients();

  const noUndefinedData = stopsData.filter((stop) => stop !== undefined) as StopDTO[];

  const filteredData = noUndefinedData.reduce((acc, stop) => {
    const location = createStopsList.getClientLocation(stop.id);

    const hasErrors = !location?.isValid();
    const hasWarnings = location?.partial_match;

    if ((showErrors || showWarnings) && !hasErrors && !hasWarnings) {
      return acc;
    }
    if (showErrors && !showWarnings && !hasErrors) {
      return acc;
    }
    if (showWarnings && !showErrors && !hasWarnings) {
      return acc;
    }
    return [...acc, stop];
  }, [] as StopDTO[]);
  // FINS AQUI EL FILTER

  const stop = filteredData[index];

  if (!stop) return null;

  const id = stop.id;
  const label = stop.label;
  const address = createStopsList.getClientAddress(id);
  const location = createStopsList.getClientLocation(id);

  const hasErrors = !location?.isValid() && !createStopsList.getIsUpdatedById(id);
  const hasWarnings = location?.partial_match;

  return (
    <div style={style}>
      <AddressRow container wrap="nowrap">
        <AddressItem
          container
          alignItems="center"
          style={{ backgroundColor: RoutalPalette.grey10, textAlign: `center`, width: `50px` }}
        >
          <Text>{index + 1}</Text>
        </AddressItem>
        <AddressItem container alignItems="center" style={{ width: `20%` }}>
          <TextWithLineClamp>{label ?? ``}</TextWithLineClamp>
        </AddressItem>
        <AddressItem container alignItems="center" style={{ width: `35%` }}>
          <TextWithLineClamp>{address ?? ``}</TextWithLineClamp>
        </AddressItem>
        <AddressItem
          container
          alignItems="center"
          style={{
            width: `45%`,
            ...(hasWarnings ? { backgroundColor: `${RoutalPalette.warning.medium}33` } : {}),
            ...(hasErrors ? { backgroundColor: `${RoutalPalette.error.medium}33` } : {}),
          }}
        >
          <InputLocation
            id={`stop-${index}`}
            fullWidth
            inputProps={{
              size: `medium`,
              variant: `clean`,
              placeholderIntlId: `location`,
            }}
            emptyIntlId="no_results"
            fieldValue={location || undefined}
            onUpdate={(newLocation) => {
              setCreateClientsList(createStopsList.setClientLocation(id, newLocation));
            }}
            optimisticUpdate
          />
        </AddressItem>
      </AddressRow>
    </div>
  );
};
